import { render } from "./InputFormAddress.vue?vue&type=template&id=05374a2e"
import script from "./InputFormAddress.vue?vue&type=script&lang=ts"
export * from "./InputFormAddress.vue?vue&type=script&lang=ts"
script.render = render

export default script